/** Auth0 Google sign-in users have a sub prefix like google-oauth2|... */
export const isGoogleAuth0User = (userId?: string | null): boolean =>
  Boolean(userId?.includes('google-oauth2'));
